import { Hr, View } from "@amzn/stencil-react-components/layout";
import { TabBar, TabPanel, TabSwitcher, useTabs } from "@amzn/stencil-react-components/tabs";
import { Text } from "@amzn/stencil-react-components/text";
import {
  CFMModuleName,
  CustomerFeedback,
  CustomerFeedbackAlignment,
  CustomerFeedbackIconPosition,
} from "@/common/components/CustomerFeedback/customer-feedback";
import { PageMainContainer } from "@amzn/it-shop-shared-components";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import React from "react";

export interface ProductAboutProps {
  description: string;
}

export const ProductAbout: React.FC<ProductAboutProps> = ({ description }) => {
  const aboutTabTitle = getString("details.tabs.about") || "About the product";
  const tabs = [{ value: aboutTabTitle, label: aboutTabTitle }];
  const { tabBarProps, tabSwitcherProps } = useTabs({ tabs });

  return (
    <PageMainContainer className="about-product-view" paddingBottom="S500" paddingTop="S500">
      <View margin={{ bottom: "S500" }}>
        <TabBar {...tabBarProps} />
      </View>

      <TabSwitcher {...tabSwitcherProps}>
        <TabPanel value={aboutTabTitle}>
          <View>
            <Text color="neutral70" fontSize="T200" fontWeight="regular" data-testid="product-description" style={{ whiteSpace: "pre-line" }}>
              {description && parse(DOMPurify.sanitize(description))}
            </Text>
            <Hr color="neutral30" />
            {description && (
              <CustomerFeedback
                moduleName={CFMModuleName.hardwareProductDetails}
                alignment={CustomerFeedbackAlignment.Left}
                position={CustomerFeedbackIconPosition.Left}
              />
            )}
          </View>
        </TabPanel>
      </TabSwitcher>
    </PageMainContainer>
  );
};
